import type {ItemPurpose} from '../../support/itemLifecycle';

/** Элемент справочника (категории, размеры, цвета…). */
export interface RefOption {
    id: string;
    code: string;
    nameRu: string;
}

/** Бренд — отдельный тип: у него нет кода, зато он создаётся на лету. */
export interface BrandOption {
    id: string;
    name: string;
}

/** Фотография в форме: либо уже загруженный ключ, либо файл в процессе загрузки. */
export interface ImageSlot {
    id: string;
    key?: string;
    file?: File;
    previewUrl: string;
    uploading?: boolean;
    error?: string;
}

/**
 * Данные вещи для режима редактирования и для проверки результата AI.
 * Исторически жил в `AddClothingItemModal`; там остался ре-экспорт для внешних
 * импортов (`utils/aiRecognition`).
 */
export interface ClothingItemEditData {
    id: string;
    name: string;
    description?: string | null;
    categoryId?: string | null;
    brandId?: string | null;
    sizeId?: string | null;
    conditionId?: string | null;
    colorIds?: string[] | null;
    layerIds?: string[] | null;
    warmthLevelId?: string | null;
    priceRub?: number | null;
    waterProof?: boolean | null;
    purchaseDate?: string | null;
    disposalDate?: string | null;
    thrownAway?: boolean | null;
    seasonIds?: string[] | null;
    materialIds?: string[] | null;
    occasionIds?: string[] | null;
    styleIds?: string[] | null;
    weatherSuitabilityIds?: string[] | null;
    defectIds?: string[] | null;
    photoUrls?: string[] | null;
    printTypeId?: string | null;
    fitId?: string | null;
    formalityId?: string | null;
    purpose?: ItemPurpose | null;
}

/** Справочники, общие для всех секций формы. */
export interface ItemFormRefs {
    categories: RefOption[];
    sizes: RefOption[];
    conditions: RefOption[];
    colors: RefOption[];
    brands: BrandOption[];
    layers: RefOption[];
    warmthLevels: RefOption[];
    seasons: RefOption[];
    materials: RefOption[];
    occasions: RefOption[];
    styles: RefOption[];
    weatherSuitabilities: RefOption[];
    defects: RefOption[];
    printTypes: RefOption[];
    fits: RefOption[];
    formalities: RefOption[];
}

export const EMPTY_ITEM_FORM_REFS: ItemFormRefs = {
    categories: [], sizes: [], conditions: [], colors: [], brands: [],
    layers: [], warmthLevels: [], seasons: [], materials: [], occasions: [],
    styles: [], weatherSuitabilities: [], defects: [], printTypes: [],
    fits: [], formalities: [],
};
